import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ga4Track, toggleInteraction } from '@unisporkal/ga4';
import { useTheme } from '@unisporkal/themes';
import { licenseSizeType } from '../../../../types/sizeType';
import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex.ts';
import styles from '../AssetSizes.module.scss';
import MarketFreeze from '../../MarketFreeze/MarketFreeze';
import UltraPack from './UltraPack/UltraPack';

const LicenseSize = ({ size, index }) => {
  const theme = useTheme();
  const themeRadio = theme.radio || {};
  const { selectedSizeIndex, setSelectedSizeIndex } = useSelectedIndex();
  const isSelected = selectedSizeIndex === index;

  const trackClick = () => {
    const ga4Event = toggleInteraction({
      toggle_interaction: 'market_freeze_toggle',
      toggle_selection: size.license,
      ui_element_location: 'acquisition_form_container',
    });

    ga4Track(ga4Event);
  };

  const handleClick = () => {
    setSelectedSizeIndex(index);
    if (size.license === 'commercial-market-freeze') {
      trackClick();
    }
  };

  return (
    <label
      className={cx({
        [themeRadio.radio]: true,
        [styles.selectedLicenseItem]: isSelected,
        [styles.licenseItem]: !isSelected,
      })}
      data-testid="asset-size"
    >
      {size.license === 'commercial-market-freeze' && (
        <MarketFreeze
          onClick={handleClick}
          isSelected={isSelected}
        />
      )}
      {size.license === 'ultrapack' && (
        <UltraPack
          onClick={handleClick}
          isSelected={isSelected}
        />
      )}
    </label>
  );
};

LicenseSize.propTypes = {
  size: licenseSizeType.isRequired,
  index: PropTypes.number.isRequired,
};

export default LicenseSize;
